import React from 'react';
import ReactDOM from 'react-dom';
import WrapApp from './WrapApp';
import reportWebVitals from './reportWebVitals';
import 'react-app-polyfill/ie11';

ReactDOM.render(
    <React.StrictMode>
        <WrapApp />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
